import React from "react";
import { Form, Row, Col, InputNumber, Divider } from "antd";

const ExtrutionMetaForm = ({ prefix }) => {
    return (
        <>
            <Divider orientation="left">Extrution</Divider>
            <Row gutter={25}>
                <Col md={12} xs={24}>
                    <Form.Item
                        label="Rejected Length"
                        name={[prefix, "rejected_length"]}
                    >
                        <InputNumber
                            defaultValue={0}
                            precision={0}
                            style={{ width: "100%" }}
                        />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item
                        label="Planned Length"
                        name={[prefix, "planned_length"]}
                        rules={[
                            {
                                required: true,
                                message: "Please input Planned Length number...!",
                            },
                        ]}
                    >
                        <InputNumber
                            defaultValue={0}
                            precision={0}
                            style={{ width: "100%" }}
                        />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item
                        label="Planned down time"
                        name={[prefix, "planned_down_time"]}
                    >
                        <InputNumber
                            addonAfter="minutes"
                            defaultValue={0}
                            precision={0}
                            style={{ width: "100%" }}
                        />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item
                        label="Machine speed"
                        name={[prefix, "machine_speed"]}
                        rules={[
                            {
                                required: true,
                                message: "Please input Machine Speed number...!",
                            },
                        ]}
                    >
                        <InputNumber
                        addonAfter="meter/min"
                            defaultValue={0}
                            precision={0}
                            style={{ width: "100%" }}
                        />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item
                        label="Wages per hour"
                        name={[prefix, "wages_per_hour"]}
                        rules={[
                            {
                                required: true,
                                message: "Please input Wages per hour...!",
                            },
                        ]}
                    >
                        <InputNumber
                            addonBefore="₹"
                            addonAfter=""
                            precision={undefined}
                            defaultValue={0}
                            style={{ width: "100%" }}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default ExtrutionMetaForm;
